// extracted by mini-css-extract-plugin
export default {"headerSwitch":"CommissionPayout_headerSwitch__tAPwJ","totalValue":"CommissionPayout_totalValue__kToNS","helperTextPosition":"CommissionPayout_helperTextPosition__F8WBD"};